import { Component, ViewChild, OnDestroy } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatBottomSheet } from '@angular/material/bottom-sheet';

import { AppService } from 'src/app/app.service';
import { TabitPayService } from 'src/app/tabit-pay/tabit-pay.service';
import { DialogsService } from 'src/app/_services/dialogs.service';
import { OrderService } from 'src/app/_services/order.service';

import { MenuComponent } from 'src/app/order-items/menu/menu.component';
import { OrderItemsSummaryComponent } from 'src/app/order-items/order-items-summary/order-items-summary.component';

@Component({
    selector: 'app-order-items',
    templateUrl: './order-items.component.html',
    styleUrl: './order-items.component.scss',
    standalone: false
})
export class OrderItemsComponent implements OnDestroy {
	@ViewChild(MenuComponent) menuComponent: MenuComponent;
	$storage: any;
	loading: boolean = true;

	constructor(
		public appService: AppService,
		public tabitPayService: TabitPayService,
		public dialog: MatDialog,
		public dialogsService: DialogsService,
		private bottomSheet: MatBottomSheet,
		public orderItemsService: OrderService
	) {
		this.$storage = this.orderItemsService.$storage;
		this.init(this.tabitPayService.$storage?.rosConfig);
		this.orderItemsService.activityTimerSubject.subscribe(status => {
			switch (status) {
				case "timeout": ; case "expired":
					this.dialog.closeAll();
					this.appService.alert({
						content: this.appService.translate('TD.msg_expired'),
					}).then(() => {
						this.cancelOrder();
					})
					break;
			}
		});
	}

	ngOnDestroy(ev?) {
		this.orderItemsService.initNewStorage();
	}

	init(config?) {
		this.appService.startBlock();
		this.orderItemsService.initAddItems(config).then((res) => {
			this.$storage = this.orderItemsService.$storage;
			this.loading = false;
		}).catch(err => {
			console.error('ERROR', err);
			if (err.type == "CANCELED") return this.goBack();
			this.appService.alert({ content: this.appService.serializeError(err) });
		}).finally(() => {
			this.appService.stopBlock();
		});
	}

	checkout() {
		if (!this.$storage?.basket.length) {
			this.appService.alert({ content: 'TD.no_basket_items' });
			return;
		}
		return new Promise((resolve, reject) => {
			let bottomSheetRef = this.bottomSheet.open(OrderItemsSummaryComponent, {
				data: {},
				direction: this.appService.direction,
				panelClass: "bottom-sheet-summary",
				disableClose: true
			});
			bottomSheetRef.afterDismissed().subscribe(result => {
				resolve(result);
			});
			let canClose = false;

			bottomSheetRef.afterOpened().subscribe(result => {
				window.setTimeout(() => {
					canClose = true;
				}, 500);
			});

			bottomSheetRef.backdropClick().subscribe(result => {
				if (canClose) {
					bottomSheetRef.dismiss();
				}
			});
		});
	}

	goBack() {
		if (this.$storage.activeSubCat) {
			this.menuComponent.menuBackClick(this.$storage.activeSubCat);
		} else {
			this.cancelOrder();
		}
	}

	cancelOrder() {
		this.appService.goBack();
	}

	searchCatalog() {
		this.menuComponent.searchCatalog();
	}
}
